import { fnList } from '../operator/group-by-function';

export const { sum, avg, min, max, first, last, count, std: sd } = fnList;
